import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { QuotationModal } from "./components/QuotationModal";
import { Preloader } from "./components/Preloader";
import RouteChangeTracker from "./components/RouteChangeTracker";
import { Toaster } from "./components/ui/sonner";
import Home from "./pages/Home";
import About from "./pages/About";
import Projects from "./pages/Projects";
import Packages from "./pages/Packages";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import Terms from "./pages/Terms";
import ThankYou from "./pages/ThankYou";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.style.overflow = '';
  }, [pathname]);
  return null;
}

function App() {
  const [isQuotationModalOpen, setIsQuotationModalOpen] = useState(false);
  const [showPreloader, setShowPreloader] = useState(true);

  const handleQuotationClick = () => {
    setIsQuotationModalOpen(true);
  };

  const handleCloseQuotation = () => {
    setIsQuotationModalOpen(false);
  };

  return (
    <HelmetProvider>
      {showPreloader && <Preloader onFinish={() => setShowPreloader(false)} />}
      <div className="App min-h-screen flex flex-col" style={showPreloader ? { visibility: 'hidden' } : {}}>
        <BrowserRouter>
          <ScrollToTop />
          <RouteChangeTracker />
          <Navbar onQuotationClick={handleQuotationClick} />
          <main className="flex-1 pt-16 sm:pt-20">
            <Routes>
              <Route path="/" element={<Home onQuotationClick={handleQuotationClick} />} />
              <Route path="/about" element={<About />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/packages" element={<Packages onQuotationClick={handleQuotationClick} />} />
              <Route path="/services" element={<Services onQuotationClick={handleQuotationClick} />} />
              <Route path="/contact" element={<Contact onQuotationClick={handleQuotationClick} />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/thank-you" element={<ThankYou />} />
            </Routes>
          </main>
          <Footer />
          <QuotationModal isOpen={isQuotationModalOpen} onClose={handleCloseQuotation} />
          <Toaster position="top-right" />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
